import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: import.meta.env.VENTAS_FIREBASE_API_KEY,
  authDomain: import.meta.env.VENTAS_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VENTAS_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VENTAS_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VENTAS_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VENTAS_FIREBASE_APP_ID,
  measurementId: import.meta.env.VENTAS_FIREBASE_MEASUREMENT_ID,
}

const isFirebaseConfigValid = Object.values(firebaseConfig).every(Boolean)

if (isFirebaseConfigValid) {
  const app = initializeApp(firebaseConfig)
  getAnalytics(app)
}
